/**
 * GLOWSERA QUIZ DATA - Configuration des 4 quiz
 * Contient toutes les questions, reponses et parametres de recommandation
 *
 * IMPORTANT: Renommez ce fichier en 'glowsera-quiz-data.js' pour l'utiliser
 */

window.GLOWSERA_QUIZ_DATA = {

  /**
   * QUIZ PEAU - 7 questions
   */
  skin: {
    title: "Diagnostic Peau",
    description: "Trouve ta routine visage idéale",

    questions: [
      {
        id: "user-name",
        type: "text",
        question: "Quel est ton prénom ?",
        placeholder: "Entrez ton prénom",
        required: true,
        answers: []
      },

      {
        id: "skin-type",
        type: "single",
        question: "Quel est ton type de peau ?",
        subtitle: "Choisis la description qui correspond le mieux à ta peau",
        required: true,
        answers: [
          {
            label: "Normale",
            subtitle: "Équilibrée, ni trop grasse ni trop sèche",
            value: "normal",
            tags: ["peau-normale"]
          },
          {
            label: "Sèche",
            subtitle: "Tiraillements, desquamation",
            value: "dry",
            tags: ["peau-seche"]
          },
          {
            label: "Grasse",
            subtitle: "Brillances, pores dilatés",
            value: "oily",
            tags: ["peau-grasse"]
          },
          {
            label: "Mixte",
            subtitle: "Zone T grasse, joues sèches",
            value: "combination",
            tags: ["peau-mixte"]
          },
          {
            label: "Sensible",
            subtitle: "Rougeurs, réactions fréquentes",
            value: "sensitive",
            tags: ["peau-sensible"]
          }
        ]
      },

      {
        id: "skin-concerns",
        type: "multiple",
        question: "Quelles sont tes principales préoccupations ?",
        subtitle: "Sélectionne jusqu'à 3 options",
        required: true,
        answers: [
          {
            label: "Hydratation",
            value: "hydration",
            tags: ["soin-hydratation"]
          },
          {
            label: "Anti-âge",
            value: "antiaging",
            tags: ["soin-anti-age"]
          },
          {
            label: "Éclat du teint",
            value: "radiance",
            tags: ["soin-eclat"]
          },
          {
            label: "Acné / Imperfections",
            value: "acne",
            tags: ["soin-acne"]
          },
          {
            label: "Taches pigmentaires",
            value: "pigmentation",
            tags: ["soin-pigmentation"]
          },
          {
            label: "Rougeurs",
            value: "redness",
            tags: ["soin-rougeurs"]
          }
        ]
      },

      {
        id: "age-range",
        type: "single",
        question: "Quelle est ta tranche d'âge ?",
        required: true,
        answers: [
          {
            label: "18-25 ans",
            value: "18-25",
            tags: ["age-18-25"]
          },
          {
            label: "26-35 ans",
            value: "26-35",
            tags: ["age-26-35"]
          },
          {
            label: "36-45 ans",
            value: "36-45",
            tags: ["age-36-45"]
          },
          {
            label: "46 ans et plus",
            value: "46plus",
            tags: ["age-46plus"]
          }
        ]
      },


      {
        id: "routine-step",
        type: "multiple",
        question: "Quelles étapes de routine cherches-tu ?",
        subtitle: "Sélectionne toutes celles qui t'intéressent",
        required: false,
        answers: [
          {
            label: "Nettoyant",
            value: "cleanser",
            tags: ["nettoyant"]
          },
          {
            label: "Sérum",
            value: "serum",
            tags: ["serum"]
          },
          {
            label: "Crème hydratante",
            value: "moisturizer",
            tags: ["hydratant"]
          },
          {
            label: "Masque",
            value: "mask",
            tags: ["masque"]
          },
          {
            label: "Soin contour des yeux",
            value: "eye-care",
            tags: ["soin-yeux"]
          },
          {
            label: "Tonique",
            value: "toner",
            tags: ["lotion-tonique"]
          },
          {
            label: "Exfoliant",
            value: "exfoliant",
            tags: ["exfoliant"]
          },
          {
            label: "Protection solaire",
            value: "sunscreen",
            tags: ["protection-solaire"]
          }
        ]
      },

    ],

    recommendations: {
      maxProducts: 12,
      maxPerVendor: 3,
      mustInclude: ["nettoyant", "hydratant"]
    }
  },

  /**
   * QUIZ CHEVEUX - 6 questions
   */
  hair: {
    title: "Diagnostic Cheveux",
    description: "Des cheveux en pleine santé",

    questions: [
      {
        id: "user-name",
        type: "text",
        question: "Quel est ton prénom ?",
        placeholder: "Entrez ton prénom",
        required: true,
        answers: []
      },

      {
        id: "hair-type",
        type: "single",
        question: "Quelle est ta masse capillaire ?",
        required: true,
        answers: [
          {
            label: "Raides",
            value: "straight",
            tags: ["cheveux-lisses"]
          },
          {
            label: "Ondulés",
            value: "wavy",
            tags: ["cheveux-ondules"]
          },
          {
            label: "Bouclés",
            value: "curly",
            tags: ["cheveux-boucles"]
          },
          {
            label: "Frisés / Crépus",
            value: "coily",
            tags: ["cheveux-crepu"]
          }
        ]
      },

      {
        id: "hair-texture",
        type: "single",
        question: "Quelle est la nature de tes cheveux ?",
        required: true,
        answers: [
          {
            label: "Fins",
            value: "fine",
            tags: ["cheveux-fins"]
          },
          {
            label: "Normaux",
            value: "normal",
            tags: ["cheveux-normaux"]
          },
          {
            label: "Épais",
            value: "thick",
            tags: ["cheveux-epais"]
          }
        ]
      },

      {
        id: "hair-concerns",
        type: "multiple",
        question: "Quelles sont tes préoccupations capillaires ?",
        subtitle: "Sélectionne jusqu'à 3 options",
        required: true,
        answers: [
          {
            label: "Cheveux secs",
            value: "dry",
            tags: ["soin-cheveux-secs"]
          },
          {
            label: "Sec en longueur",
            value: "dry-lengths",
            tags: ["soin-longueurs-seches"]
          },
          {
            label: "Cheveux gras",
            value: "oily",
            tags: ["soin-cheveux-gras"]
          },
          {
            label: "Gras en racine",
            value: "oily-roots",
            tags: ["soin-racines-grasses"]
          },
          {
            label: "Pellicules",
            value: "dandruff",
            tags: ["soin-pellicules"]
          },
          {
            label: "Chute de cheveux",
            value: "hair-loss",
            tags: ["soin-chute-cheveux"]
          },
          {
            label: "Cheveux abimés",
            value: "damaged",
            tags: ["soin-cheveux-abimes"]
          },
          {
            label: "Manque de volume",
            value: "volume",
            tags: ["soin-volume"]
          },
          {
            label: "Frisottis",
            value: "frizz",
            tags: ["soin-frisottis"]
          }
        ]
      },

      {
        id: "hair-chemical-treatment",
        type: "single",
        question: "Tes cheveux sont-ils traités chimiquement ?",
        required: true,
        answers: [
          {
            label: "Non, cheveux naturels",
            value: "natural",
            tags: ["cheveux-naturels"]
          },
          {
            label: "Oui, colorés",
            value: "colored",
            tags: ["cheveux-colores"]
          },
          {
            label: "Oui, décolorés / mèches",
            value: "bleached",
            tags: ["cheveux-decolores"]
          },
          {
            label: "Oui, dénaturés (lissage/permanente)",
            value: "chemically-altered",
            tags: ["cheveux-traites-chimiquement"]
          }
        ]
      },

      {
        id: "hair-goals",
        type: "multiple",
        question: "Quels sont tes objectifs capillaires ?",
        required: true,
        answers: [
          {
            label: "Hydratation intense",
            value: "hydration",
            tags: ["soin-hydratation"]
          },
          {
            label: "Réparation",
            value: "repair",
            tags: ["soin-cheveux-abimes"]
          },
          {
            label: "Brillance",
            value: "shine",
            tags: []
          },
          {
            label: "Volume",
            value: "volume",
            tags: ["soin-volume"]
          },
          {
            label: "Lissage / Anti-frisottis",
            value: "smoothing",
            tags: ["soin-frisottis"]
          },
          {
            label: "Chute de cheveux",
            value: "hair-loss",
            tags: ["soin-chute-cheveux"]
          }
        ]
      }
    ],

    recommendations: {
      maxProducts: 12,
      maxPerVendor: 3,
      mustInclude: ["shampoing", "apres-shampoing"]
    }
  },

  /**
   * QUIZ MAQUILLAGE - 5 questions
   */
  makeup: {
    title: "Diagnostic Maquillage",
    description: "Un look qui te ressemble",

    questions: [
      {
        id: "user-name",
        type: "text",
        question: "Quel est ton prénom ?",
        placeholder: "Entrez ton prénom",
        required: true,
        answers: []
      },

      {
        id: "skin-tone",
        type: "single",
        question: "Quelle est ta carnation ?",
        required: true,
        answers: [
          {
            label: "Claire",
            value: "light",
            tags: ["teint-clair"]
          },
          {
            label: "Moyenne",
            value: "medium",
            tags: ["teint-medium"]
          },
          {
            label: "Foncée",
            value: "deep",
            tags: ["teint-profond"]
          }
        ]
      },

      {
        id: "finish",
        type: "single",
        question: "Quelle finition préfères-tu ?",
        required: true,
        answers: [
          {
            label: "Mate",
            subtitle: "Effet poudre, sans brillance",
            value: "matte",
            tags: ["fini-mat"]
          },
          {
            label: "Satinée",
            subtitle: "Fini naturel, léger éclat",
            value: "satin",
            tags: ["fini-satin"]
          },
          {
            label: "Lumineuse / Dewy",
            subtitle: "Peau glowy, effet rosé",
            value: "dewy",
            tags: ["fini-lumineux"]
          }
        ]
      },

      {
        id: "makeup-style",
        type: "single",
        question: "Quel est ton style de maquillage ?",
        required: true,
        answers: [
          {
            label: "Naturel / No-makeup",
            value: "natural",
            tags: ["style-naturel"]
          },
          {
            label: "Quotidien / Élégant",
            value: "everyday",
            tags: ["style-quotidien"]
          },
          {
            label: "Glamour / Soirée",
            value: "glam",
            tags: ["style-glam"]
          },
          {
            label: "Audacieux / Créatif",
            value: "bold",
            tags: ["style-audacieux"]
          }
        ]
      },

      {
        id: "products-needed",
        type: "multiple",
        question: "Quels produits cherches-tu ?",
        subtitle: "Sélectionne tous ceux qui t'intéressent",
        required: true,
        answers: [
          {
            label: "Fond de teint",
            value: "foundation",
            tags: ["fond-de-teint"]
          },
          {
            label: "Anticernes",
            value: "concealer",
            tags: ["correcteur"]
          },
          {
            label: "Mascara",
            value: "mascara",
            tags: ["mascara"]
          },
          {
            label: "Rouge à lèvres",
            value: "lipstick",
            tags: ["rouge-a-levres"]
          },
          {
            label: "Blush",
            value: "blush",
            tags: ["blush"]
          },
          {
            label: "Fard à paupières",
            value: "eyeshadow",
            tags: ["fard-a-paupieres"]
          },
          {
            label: "Eyeliner",
            value: "eyeliner",
            tags: ["eye-liner"]
          },
          {
            label: "Sourcils",
            value: "brow",
            tags: ["sourcils"]
          },
          {
            label: "Poudre",
            value: "powder",
            tags: ["poudre"]
          },
          {
            label: "Primer",
            value: "primer",
            tags: ["base"]
          }
        ]
      },

    ],

    recommendations: {
      maxProducts: 12,
      maxPerVendor: 3,
      mustInclude: []
    }
  },

  /**
   * QUIZ CORPS - 5 questions
   */
  body: {
    title: "Diagnostic Corps",
    description: "Prends soin de ta peau",

    questions: [
      {
        id: "user-name",
        type: "text",
        question: "Quel est ton prénom ?",
        placeholder: "Entrez ton prénom",
        required: true,
        answers: []
      },

      {
        id: "body-skin-type",
        type: "single",
        question: "Quel est ton type de peau corporelle ?",
        required: true,
        answers: [
          {
            label: "Normale",
            subtitle: "Équilibrée, confortable",
            value: "normal",
            tags: ["corps-peau-normale"]
          },
          {
            label: "Sèche",
            subtitle: "Tiraillements, rugosités",
            value: "dry",
            tags: ["corps-peau-seche"]
          },
          {
            label: "Très sèche",
            subtitle: "Desquamation, démangeaisons",
            value: "very-dry",
            tags: ["corps-peau-seche"]
          },
          {
            label: "Sensible",
            subtitle: "Rougeurs, réactions",
            value: "sensitive",
            tags: ["corps-peau-sensible"]
          }
        ]
      },

      {
        id: "body-concerns",
        type: "multiple",
        question: "Quelles sont tes préoccupations ?",
        subtitle: "Sélectionne jusqu'à 3 options",
        required: true,
        answers: [
          {
            label: "Hydratation",
            value: "hydration",
            tags: ["soin-hydratation"]
          },
          {
            label: "Fermeté",
            value: "firmness",
            tags: ["soin-fermete"]
          },
          {
            label: "Vergetures",
            value: "stretch-marks",
            tags: ["soin-vergetures"]
          },
          {
            label: "Cellulite",
            value: "cellulite",
            tags: ["soin-cellulite"]
          },
          {
            label: "Mains sèches",
            value: "dry-hands",
            tags: ["soin-mains-seches"]
          },
          {
            label: "Pieds abimés",
            value: "damaged-feet",
            tags: ["creme-pieds"]
          }
        ]
      },

      {
        id: "texture-preference",
        type: "single",
        question: "Quelle texture préfères-tu ?",
        required: true,
        answers: [
          {
            label: "Légère / Lait",
            subtitle: "Absorption rapide",
            value: "light",
            tags: ["texture-legere"]
          },
          {
            label: "Riche / Baume",
            subtitle: "Nourrissante",
            value: "rich",
            tags: ["texture-riche"]
          },
          {
            label: "Huile",
            subtitle: "Ultra-nourrissante",
            value: "oil",
            tags: ["texture-huile"]
          }
        ]
      },

      {
        id: "products-needed",
        type: "multiple",
        question: "Quels produits cherches-tu ?",
        subtitle: "Sélectionne tous ceux qui t'intéressent",
        required: true,
        answers: [
          {
            label: "Gel douche / Savon",
            value: "body-wash",
            tags: ["gel-douche"]
          },
          {
            label: "Lait / Crème corps",
            value: "body-lotion",
            tags: ["lotion-corps"]
          },
          {
            label: "Gommage corps",
            value: "body-scrub",
            tags: ["gommage-corps"]
          },
          {
            label: "Huile corps",
            value: "body-oil",
            tags: ["huile-corps"]
          },
          {
            label: "Crème mains",
            value: "hand-cream",
            tags: ["creme-mains"]
          },
          {
            label: "Soin pieds",
            value: "foot-cream",
            tags: ["creme-pieds"]
          },
          {
            label: "Déodorant",
            value: "deodorant",
            tags: ["deodorant"]
          }
        ]
      },

    ],

    recommendations: {
      maxProducts: 12,
      maxPerVendor: 3,
      mustInclude: ["lotion-corps"]
    }
  }

};

console.log('[Glowsera Quiz Data] Données chargées pour', Object.keys(window.GLOWSERA_QUIZ_DATA).length, 'quiz');
